import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Download, RefreshCw, Loader2 } from "lucide-react";
import { downloadImage } from "@/lib/world-helpers";

interface ImageLightboxProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  imageUrl: string | null;
  title: string;
  onRegenerate?: () => void;
  regenerating?: boolean;
  /** Extra action buttons to render in the footer */
  extraActions?: React.ReactNode;
}

export function ImageLightbox({
  open, onOpenChange, imageUrl, title,
  onRegenerate, regenerating, extraActions,
}: ImageLightboxProps) {
  if (!imageUrl) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg p-0 overflow-hidden">
        <div>
          <img src={imageUrl} alt={title} className="w-full max-h-[70vh] object-contain bg-black" onError={(e) => { (e.target as HTMLImageElement).style.display = "none"; }} />
          <div className="p-3 flex items-center justify-between">
            <h3 className="text-sm font-semibold text-foreground">{title}</h3>
            <div className="flex gap-1">
              <Button
                variant="outline"
                size="sm"
                className="gap-1.5 text-xs"
                onClick={() => downloadImage(imageUrl, `${title}_portrait`)}
              >
                <Download className="w-3 h-3" /> Download
              </Button>
              {onRegenerate && (
                <Button
                  variant="outline"
                  size="sm"
                  className="gap-1.5 text-xs"
                  onClick={onRegenerate}
                  disabled={regenerating}
                >
                  {regenerating ? <Loader2 className="w-3 h-3 animate-spin" /> : <RefreshCw className="w-3 h-3" />}
                  Regenerate
                </Button>
              )}
              {extraActions}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
